import { Component, OnInit } from '@angular/core';
import {  FormGroup, FormBuilder, FormControl, Validators, NgForm } from '@angular/forms';
import { ServicesService } from '../app.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})

export class ContactFormComponent implements OnInit {
  form: FormGroup;
  alert: boolean = false;

  constructor(private formBuilder: FormBuilder, private contact: ServicesService) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      Fullname: [null, [Validators.required, Validators.minLength(3)]],
      Email: [null, [Validators.required, Validators.email]],
      Subject: [null],
      Comment: [null, Validators.required]
    });
  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field)
    };
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);

      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  reset(){
    this.form.reset();
  }

  onSubmit(form) {
    //console.log(form)
    this.contact.PostMessage(form)
      .subscribe(response => {
        location.href = 'https://mailthis.to/confirm'
        console.log(response)
        this.reset();
        this.alert= true;
      }, error => {
        this.validateAllFormFields(this.form.value)
        console.warn(error.responseText)
        console.log({ error })
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts